import React, { createContext, useState } from 'react';

export const initialChargebackConfigDataValues = {
  providersConfigData: {},
  setProvidersConfigData: () => {},
  currentBusiness: [],
  setCurrentBusiness: () => {},
  allOrderData: {},
  setOrderData: () => {},
};

const ChargeBackContext = createContext(initialChargebackConfigDataValues);

const ChargeBackContextProvider = ({children}) => {
  const [providersConfigData, setProvidersConfigData] = useState({});
  const [currentBusiness, setCurrentBusiness] = useState([]);
  const [allOrderData, setOrderData] = useState([]);
  return (
    <ChargeBackContext.Provider
      value={{
        providersConfigData,
        setProvidersConfigData,
        currentBusiness,
        setCurrentBusiness,
        allOrderData,
        setOrderData,
      }}
    >
      {children}
    </ChargeBackContext.Provider>
  );
};

const ChargeBackContextConsumer = ({ children }) => {
  return <ChargeBackContext.Consumer>{children}</ChargeBackContext.Consumer>;
};

export { ChargeBackContext, ChargeBackContextProvider, ChargeBackContextConsumer };